<template>
    <div class="customer-person-responsible-import">
        <list-layout-paper>
            <template v-slot:list="{ tableHeight }">
                <div class="import-content">
                    <div>
                        <p>得分导入：</p>
                        <lotsButton
                            icon="el-icon-upload2"
                            type="primary"
                            size="mini"
                            title="导入"
                            @click="openImport">得分导入
                        </lotsButton>
                        <lotsButton
                            icon="el-icon-delete"
                            type="primary"
                            size="mini"
                            title="删除"
                            @click="handleDelete">删除
                        </lotsButton>
                    </div>
                    <div>
                        <p>明细导入：</p>
                        <lotsButton
                            icon="el-icon-upload2"
                            type="primary"
                            size="mini"
                            title="导入"
                            @click="openDetailImport">明细导入
                        </lotsButton>
                    </div>
                </div>
            </template>
        </list-layout-paper>

        <!-- 导入弹窗 -->
        <addFileDialog
            ref="fileDialogRef"
            :config="importConfig"
          >
        </addFileDialog>
    </div>
</template>

<script>
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsButton from '@/components/lots/lotsButton';
import addFileDialog from '@/modules/mdm/components/addFileDialog/Index.vue';
import { deleteCustomerPersonResponsibleImport } from '@mdm/api/customer/customerPersonResponsibleImport.js';
import { reactive, ref } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import { config, detailConfig } from './config';

export default {
    name: 'customerPersonResponsibleImport',
    components: {
        listLayoutPaper,
        lotsButton,
        addFileDialog
    },
    setup(props, setupContext) {
        const importConfig = ref({});

        // 打开导入弹窗
        const openImport = () => {
            importConfig.value = config;
            setupContext.refs.fileDialogRef.openImport();
        };

        // 打开【收入】责任制数据初始化导入弹窗
        const openDetailImport = () => {
            importConfig.value = detailConfig;
            setupContext.refs.fileDialogRef.openImport();
        };

        // 删除操作
        const handleDelete = () => {
            MessageBox.confirm('确认删除导入的全部数据吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                deleteCustomerPersonResponsibleImport({}).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                    } else {
                        Message.error(res.msg || '删除失败');
                    }
                }).catch(() => {
                    Message.error('删除失败');
                });
            });
        };
        return {
            importConfig,
            handleDelete,
            openImport,
            openDetailImport
        };
    }
};
</script>

<style lang="less" scoped>
.customer-person-responsible-import {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column;

    .import-content {
        display: flex;
        flex-direction: column;
        // justify-content: center;
        align-items: center;
        height: 100%;
        min-height: calc(100vh - 200px);
        padding: 20px;

        & > div {
            width: 150px;
        }
    }

    .header-button {
        margin-left: 10px;
    }

    :deep(.list-layout-paper) {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    :deep(.list-layout-wrapper) {
        flex: 1;
        display: flex;
        flex-direction: column;
    }

    :deep(.list-main) {
        flex: 1;
    }
}
</style>
